import React from 'react';
import { Typography, Stack, Button } from '@mui/material';
import StandardDialog from '../../../../shared_components/components/StandardDialog/StandardDialog';

interface PatientConsentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PatientConsentModal: React.FC<PatientConsentModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <StandardDialog open={isOpen} onClose={onClose} title="Obtain Patient Consent" maxWidth="sm" closeText="Cancel">
      <Stack spacing={2}>
        <Typography variant="body1">
          "I may use AI-powered note taking during this consult to help capture accurate records. Do you consent?"
        </Typography>
        <Button variant="contained" onClick={onConfirm} sx={{ borderRadius: '4px' }}>
          I HAVE THE PATIENT’S CONSENT TO USE AMBIENT LISTENING
        </Button>
      </Stack>
    </StandardDialog>
  );
};

export default PatientConsentModal;
